import { SR_API_ACTION_UTILITY_LOGIN } from 'api/utilityActionTypes';

import { ANALYTICS_EVENT_UTILITY_USER_LOGIN } from 'client/analytics/eventList';

import { hasRolePartner } from 'common/utility/userRoles';

import { onLogicSuccess as onPartnerLoginSuccess } from 'client/actions/UtilityAuth/partnerSignup';

import { onLogicSuccess as onUserLogicSuccess } from 'client/actions/UtilityAuth/userSignup';

import analytics from 'client/analytics';

export default async function login({ state, utilityApiClient }, payload) {
  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_LOGIN,
    state: state,
    payload,
    async onSuccess({ user }) {
      if (hasRolePartner(user.roles)) {
        await onPartnerLoginSuccess({
          state,
          utilityApiClient,
          user,
        });
      } else {
        await onUserLogicSuccess({
          state,
          utilityApiClient,
          user,
        });
      }

      analytics.track(ANALYTICS_EVENT_UTILITY_USER_LOGIN);

      return user;
    },
    onError(error) {
      throw error;
    },
  });
}
